export const trackingIdAndAnonymousLocalSelector = ({trackingIdAndAnonymousLocal}) => trackingIdAndAnonymousLocal